import _ from "lodash";
import {
    CollaboratorsActionTypes,
    IDeleteCollaboratorAction,
    CollaboratorsState,
    IAddCollaboratorWithTempIdAction,
    IChangeCollaboratorRoleAction,
} from "./types";
import { Handler } from "../types/store-types";
import { CollaborationStatus, CollaboratorRole } from "./../collaborators/types";

const addWithTempId: Handler<CollaboratorsState, IAddCollaboratorWithTempIdAction> = (
    state,
    { payload: newCollaborator },
) => {
    return { ...state, list: [...state.list, newCollaborator] };
};

const deleteCollaborator: Handler<CollaboratorsState, IDeleteCollaboratorAction> = (
    state,
    { payload: { id: deletingId } },
) => {
    const list = _.cloneDeep(state.list).filter(collaborator => collaborator.id !== deletingId);

    return { ...state, list };
};

const changeRole: Handler<CollaboratorsState, IChangeCollaboratorRoleAction> = (
    state,
    { payload: { id, newRole } },
) => {
    let changedColoborator = state.owner;
    const list = _.cloneDeep(state.list).map(collaborator => {
        if (id === collaborator.id) {
            switch (newRole) {
                case CollaboratorRole.Owner:
                    changedColoborator = {
                        ...collaborator,
                        role: CollaboratorRole.Owner,
                        status: CollaborationStatus.Pending,
                    };
                    return { ...state.owner, role: collaborator.role, status: CollaborationStatus.Pending };
                default:
                    return { ...collaborator, role: newRole };
            }
        } else return collaborator;
    });

    return { ...state, list, owner: changedColoborator };
};

export const handlersCollaborators = {
    [CollaboratorsActionTypes.ADD_WITH_TEMP_ID]: addWithTempId,
    [CollaboratorsActionTypes.DELETE]: deleteCollaborator,
    [CollaboratorsActionTypes.CHANGE_ROLE]: changeRole,
};
